// removed by extract-text-webpack-plugin
module.exports = {"root":"_1e8Jr","input":"_2hEFw","spacer":"_2hIbp","btnContainer":"_LDZxv"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Account/children/AccountReferral/components/CopyReferral/CopyReferral.scss
// module id = 901
// module chunks = 34